import { createRoute } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { StopNetworkAreaRoutes } from '@backoffice-frontend/sam-common'
import { useGlobalServiceAreaIds } from '@backoffice-frontend/service-area-picker'
import { NetworkIcon } from '@moia-dev/pace-icons'
import { useStopNetworkPermissions } from './hooks/useStopNetworkPermissions'

export const StopNetworkAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const [{ id: globalServiceAreaId }] = useGlobalServiceAreaIds()
  const { canReadDashboard: hasStopNetworkDashboardAccess } =
    useStopNetworkPermissions()
  const overviewRoute = globalServiceAreaId
    ? createRoute(StopNetworkAreaRoutes.Show.Overview.route, {
        serviceAreaId: globalServiceAreaId,
      })
    : StopNetworkAreaRoutes.Show.Overview.route
  const stopNetworkRoute = globalServiceAreaId
    ? createRoute(StopNetworkAreaRoutes.Show.route, {
        serviceAreaId: globalServiceAreaId,
      })
    : StopNetworkAreaRoutes.route
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={hasStopNetworkDashboardAccess ? overviewRoute : stopNetworkRoute}
      Icon={NetworkIcon}
    />
  )
}
